var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',{attrs:{"outlined":""}},[_c('chain-table-banner',{attrs:{"table":_vm.table},on:{"editChainTable":_vm.editChainTable}}),_c('v-container',{staticClass:"pa-0",staticStyle:{"overflow-x":"auto"}},[_c('v-container',{style:({
        minWidth: `${_vm.tableWidth + 'px'}`,
      })},[_c('chain-table-header',{attrs:{"header":_vm.header}}),_vm._l((_vm.nodes),function(node){return _c('chain-table-row',{key:node.id,attrs:{"node":node,"table":_vm.table}})})],2)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }